import { render, staticRenderFns } from "./Logoutauto.vue?vue&type=template&id=bc92ef8a&scoped=true&"
import script from "./Logoutauto.vue?vue&type=script&lang=js&"
export * from "./Logoutauto.vue?vue&type=script&lang=js&"
import style0 from "./Logoutauto.vue?vue&type=style&index=0&id=bc92ef8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc92ef8a",
  null
  
)

export default component.exports